<template>
    <div class="w-full flex justify-between items-center py-2 block border border-white">
        <div class="flex items-center">
            <div class="item-number cursor-pointer py-1 px-2">
                <span v-if="type === 'child'">{{ parent.order+1 }}.</span>
                <span>{{ note.order+1 }}</span>
            </div>
            <div >{{ note.title }}</div>
            <a v-if="note.link_to_file" :href="`/storage/${note.link_to_file}`" target="_blank" class="px-4 text-xs text-blue-600 hover:text-blue-800 flex items-center">
                <svg class="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                <span>View File</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        note: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        parent: {
            type: Object,
        }
    },
}
</script>

